
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { diagnoseConnectionIssue, ConnectionTestResult } from "@/utils/supabaseConnectionTest";

interface LoadingScreenProps {
  authError?: string | null;
  connectionStatus?: ConnectionTestResult | null;
  onRetry?: () => void;
}

export const LoadingScreen = ({ authError, connectionStatus, onRetry }: LoadingScreenProps) => {
  console.log("=== SHOWING LOADING ===");
  console.log("Showing loading screen");

  return (
    <div className="min-h-screen bg-gradient-to-br from-bg-gradient-from to-bg-gradient-to flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-green-600 text-lg mb-4">Loading YieldShare...</div>
        {authError && (
          <div className="text-red-600 text-sm mb-4">
            Connection issue detected. Retrying...
          </div>
        )}
        {connectionStatus && !connectionStatus.success && (
          <div className="text-orange-600 text-sm mb-4">
            {diagnoseConnectionIssue(connectionStatus)}
          </div>
        )}
        {onRetry && (
          <div className="mt-4">
            <Button onClick={onRetry} variant="outline" size="sm">
              <RefreshCw className="mr-2 h-4 w-4" />
              Retry
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
